/**
 * B2B service catalogue (FRD §3.3).
 *
 * Slugs match backend/db/service-catalog.js so the build track can join to the
 * existing services table without a translation layer. `code` is the tag prefix
 * used by the piece-tagging logic (FRD §7) - WI-1/20, DC-1/3 - and is the single
 * source of truth for those prefixes.
 */
import type { EntryType } from './types'

export interface B2bService {
  slug: string
  label: string
  entryType: EntryType
  /** Tag prefix printed on every piece label. */
  code: string
  /** Selectable items for item-based services. */
  items: string[]
}

export const B2B_SERVICES: B2bService[] = [
  {
    slug: 'wash-and-iron',
    label: 'Wash & Iron',
    entryType: 'weight',
    code: 'WI',
    items: [],
  },
  {
    slug: 'dry-cleaning',
    label: 'Dry Cleaning',
    entryType: 'items',
    code: 'DC',
    items: ['Shirt', 'Trouser', 'Saree', 'Blazer', 'Suit', 'Blanket', 'Curtain'],
  },
  {
    slug: 'shoe-care',
    label: 'Shoe Care',
    entryType: 'items',
    code: 'SC',
    items: ['Cleaning', 'Polish', 'Sole Repair', 'Deep Clean'],
  },
]

export const serviceBySlug = (slug: string): B2bService | undefined =>
  B2B_SERVICES.find((service) => service.slug === slug)

export const serviceLabel = (slug: string): string => serviceBySlug(slug)?.label ?? slug

export const serviceCode = (slug: string): string =>
  serviceBySlug(slug)?.code ?? slug.slice(0, 2).toUpperCase()

/** Rate-card key for an item price. Keep in sync with B2bRateCard.itemPrices. */
export const itemPriceKey = (serviceSlug: string, itemName: string) =>
  `${serviceSlug}:${itemName}`
